import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import {API_CHECKOUT  } from "../../../utils/constants"

function ApplePay({ setSuccessPayment, price, setPaymentInfo, setStartCall,setTypeCreditCard }) {
  const [stripePromise, setStripePromise] = useState(null);
  // const [clientSecret, setClientSecret] = useState("");
  const [amount, setAmount] = useState(price);

  useEffect(() => {
    fetch(`${API_CHECKOUT}config`).then(async (r) => {
    // fetch("/config").then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);

  return (
    <>
      {stripePromise && (
        <Elements stripe={stripePromise}>
          <CheckoutForm
            setSuccessPayment={setSuccessPayment}
            setPaymentInfo={setPaymentInfo}
            setStartCall={setStartCall}
            amount={amount}
            setTypeCreditCard={setTypeCreditCard}
          />
        </Elements>
      )}
    </>
  );
}

export default ApplePay;
